<div
  class="flex items-center gap-2 px-3 py-2 rounded-full bg-white/60 dark:bg-white/10 border border-white/50 shadow-[0_2px_4px_rgba(0,0,0,0.05)] w-fit"
>
  <!-- Play / Pause button -->
  <button
    type="button"
    (click)="toggle()"
    class="w-8 h-8 rounded-full bg-primary flex items-center justify-center shrink-0 hover:bg-primary/90 active:scale-95 transition-all cursor-pointer"
  >
    <span
      class="material-symbols-outlined text-white !text-[16px] leading-none"
    >
      {{ isPlaying() ? 'pause' : 'play_arrow' }}
    </span>
  </button>

  <!-- Waveform bars -->
  <om-waveform-bars
    [isAnimating]="isPlaying()"
    [heightPx]="24"
    [barCount]="barCount()"
  />

  <!-- Time display -->
  <span
    class="text-xs font-medium text-slate-600 dark:text-white/60 shrink-0 font-mono"
  >
    {{ isPlaying() ? formattedCurrent() : formattedTotal() }}
  </span>
</div>
